import React from "react";
import styled from "styled-components";
import { useTable, usePagination } from "react-table";
import { connect } from "react-redux";
import {
  ChevronRightIcon,
  ChevronLeftIcon,
//   ChevronDoubleRightIcon,
//   ChevronDoubleLeftIcon,
} from "@heroicons/react/outline";

function Table({ columns, data, themes, detail }) {
    // console.log(themes)
    const Styles = styled.div`
        table {
            color: ${themes === "light" ? "#37414f" : "#cecece"};
        width: 100%;
        text-align: center;
        thead {
            color: white;
            background-color: #3b81f6;
            tr {
            th {
                :first-child {
                border-radius: 10px 0px 0px 0px;
                }
                :last-child {
                border-radius: 0px 10px 0px 0px;
                }
            }
            }
        }

        tbody {
            background: ${themes !== "light" ? "#1f2937" : "#eaeaea"};
            tr:hover{
                background: ${themes !== "light" ? "#0b1522" : "#c5c5c5"};
            }
        }
        tr {
            :last-child {
            td {
                border-bottom: 0;
                :first-child {
                border-radius: 0px 0px 0px 10px;
                }
                :last-child {
                border-radius: 0px 0px 10px 0px;
                }
            }
            }
        }

        th,
        td {
            margin: 0;
            padding: 0.5rem;

            :last-child {
            border-right: 0;
            }
        }
        }

        .pagination {
        padding: 0.5rem;
        }
    `;
    // Use the state and functions returned from useTable to build your UI
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        // rows,
        prepareRow,
        page, // Instead of using 'rows', we'll use page,
        // which has only the rows for the active page
    
        // The rest of these things are super handy, too ;)
        // canPreviousPage,
        // canNextPage,
        pageOptions,
        // pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0 },
        },
        usePagination,
    )

    // Render the UI for your table
    return (
        
        <>
        <Styles>
            <table {...getTableProps()}>
            <thead>
                {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                    </th>
                    ))}
                </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                prepareRow(row);
                return (
                    <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                        return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                        );
                    })}
                    </tr>
                );
                })}
            </tbody>
            </table>
            {/* 
            Pagination can be built however you'd like. 
            This is just a very basic UI implementation:
            */}
            <div className="pagination my-2">
            <button
                onClick={() => previousPage()}
                className="p-2 bg-blue-200 dark:bg-gray-800 rounded"
            >
                <ChevronLeftIcon className="h-4 w-4" />
            </button>{" "}
            <button
                onClick={() => nextPage()}
                className="p-2 bg-blue-200 dark:bg-gray-800 rounded"
            >
                <ChevronRightIcon className="h-4 w-4" />
            </button>{" "}
            <span>
                Page{" "}
                <strong>
                {pageIndex + 1} of {pageOptions.length}
                </strong>{" "}
            </span>
            <span>
                | Go to page:{" "}
                <input
                type="number"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                    const page = e.target.value ? Number(e.target.value) - 1 : 0;
                    gotoPage(page);
                }}
                style={{ width: "100px" }}
                className="border px-2 py-1 rounded-lg border-gray-300 dark:bg-gray-800"
                />
            </span>{" "}
            <select
                value={pageSize}
                onChange={(e) => {
                setPageSize(Number(e.target.value));
                }}
                className="border px-2 rounded-lg py-1 dark:bg-gray-800"
            >
                {[5, 10, 20, 30, 40, 50].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                </option>
                ))}
            </select>
            </div>
        </Styles>
        </>
    );
    }

    const mapStateToProps = (state) => {
    return {
        themes: state.darkmode.theme,
    };
};

export default connect(mapStateToProps)(Table);